module.exports = __webpack_public_path__ + "media/app/assets/icon-frame-large-1eb269b9e3d7baca5cec57590c938ed9.png";